import { JsonParam, StringParam, UrlUpdateType, useQueryParam } from 'use-query-params';

import { ActionDialogType } from './constants';

export const useActiveActionDialogType = () =>
  useQueryParam('activeActionDialog', StringParam) as [
    ActionDialogType | undefined,
    (newValue: ActionDialogType | undefined, updateType?: UrlUpdateType) => void
  ];

export const useAdditionalParamsDialog = () =>
  useQueryParam('additionalParams', JsonParam) as [
    Record<string, any> | undefined,
    (newValue: Record<string, any> | undefined, updateType?: UrlUpdateType) => void
  ];
